/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { toHeaderCase, toLowerCase } from 'js-convert-case';

import moment from 'moment';

export interface IFormatTimelineDetailMethods extends IPluginMethodMap {
  getFormatTimelineDetailSync(args: any): any;
}

const lookup = require('country-code-lookup');

export class FormatTimelineDetailPlugin implements IAgentPlugin {
  readonly methods: IFormatTimelineDetailMethods;

  constructor() {
    this.methods = {
      getFormatTimelineDetailSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      title: toHeaderCase(
        args?.data?.find((item: any) => item?.id === args?.cardId)?.action ?? ''
      ),
      data: this.getDetail(args),
    };
  }

  private getDetail(res: any) {
    console.log(`timeline details`, res);
    let _temp = res?.data?.find((item: any) => item?.id === res?.cardId);
    let _timelineDetail = this.getTimeLineDetail(_temp?.payload);
    console.log(`_temp id`, _temp);
    if (_timelineDetail) {
      return {
        type: 'multi-col-list',
        numberOfColumns: '3',
        data: [..._timelineDetail],
      };
    } else return null;
  }

  private getTimeLineDetail(res: any) {
    let _temp = [];
    if (res?.discountedPremium === res?.premium) {
      delete res?.discountedPremium;
    }
    if (res) {
      for (const [key, value] of Object.entries(res)) {
        if (typeof value === 'string') {
          if (toLowerCase(key)?.includes('date')) {
            _temp.push({
              title: toHeaderCase(key),
              subTitle: moment(value).format('LLL'),
            });
          } else if (key === 'paymentMethod') {
            _temp.push({
              title: toHeaderCase(key),
              subTitle: toHeaderCase(value),
            });
          } else if (key === 'blockchainTxnURL') {
            _temp.push({
              title: toHeaderCase('Blockchain Proof URL'),
              subTitle: value,
            });
          } else if (key === 'hash') {
            _temp.push({
              title: toHeaderCase('Blockchain Proof'),
              subTitle: 'View Proof',
              isModal: true,
            });
          } else if (key === 'receiptNo') {
            _temp.push({
              title: toHeaderCase('Transaction Id'),
              subTitle: value,
            });
          } else if (key === 'instrumentNo') {
            _temp.push({
              title: toHeaderCase('Receipt Number'),
              subTitle: value,
            });
          } else {
            _temp.push({
              title: toHeaderCase(key),
              subTitle: value,
            });
          }
        }
        if (typeof value === 'object' && key === 'address') {
          _temp.push({
            title: toHeaderCase(key),
            subTitle: `${value?.addressLine1}, ${value?.city}, ${value?.country}`,
          });
        }
      }
    }
    return _temp;
  }
}
